import { acceptHMRUpdate, defineStore } from 'pinia'
import { districtCtv } from '@services/options'
import { computed, ref } from 'vue'
import { useCachedRequest } from '@composables/useCachedRequest'

export type ApiCtv = {
  idctv: number
  ctvName: string
  ctvDistrict: string
  districtName: string
}

export const useCtvCachedStore = defineStore('ctvCache', () => {
  const selectedDistrictCode = ref<string | null>(null)

  const g = async (dCode: string) => {
    const result = await districtCtv(dCode)
    if (!result.status) throw new Error(result.message)
    return result.data
  }

  const { data: ctvs, error, message, isLoading, isReady } = useCachedRequest<ApiCtv[], string>(selectedDistrictCode, g)

  const setDistrictCode = (code: string) => {
    selectedDistrictCode.value = code
  }

  const districtName = computed(() => {
    return (districtCode: string) => {
      return ctvs.value?.find((ctv: ApiCtv) => ctv.ctvDistrict == districtCode)?.districtName ?? districtCode
    }
  })

  const ctvName = computed(() => {
    return (ctvId: number) => ctvs.value?.find((ctv: ApiCtv) => ctv.idctv == ctvId)?.ctvName ?? ctvId.toString()
  })

  const fetchCTVs = async (dCode: string) => {
    error.value = undefined
    isLoading.value = true
    selectedDistrictCode.value = dCode

    return async () => {
      const result = await districtCtv(selectedDistrictCode.value)
      if (result.status) {
        ctvs.value = result.data
      } else {
        error.value = true
        message.value = result.message
      }
      isLoading.value = false
    }
  }

  return {
    fetchCTVs,
    setDistrictCode,
    districtName,
    ctvName,
    ctvs,
    error,
    message,
    isLoading,
    isReady,
  }
})

export const useCtvStore = defineStore('ctv', {
  state: () => {
    return {
      ctvs: undefined as unknown as ApiCtv[],
      error: false,
      message: null,
      isLoading: false,
    }
  },
  getters: {
    districtName(state) {
      console.log(state)
      return (districtCode: string) =>
        state.ctvs?.find((ctv) => ctv.ctvDistrict == districtCode)?.districtName ?? districtCode
    },
    ctvName(state) {
      console.log(state)
      return (ctvId: number) => state.ctvs?.find((ctv) => ctv.idctv == ctvId)?.ctvName ?? ctvId
    },
  },
  actions: {
    async fetchCtvs(district: string) {
      this.error = false
      this.message = null
      this.isLoading = true

      const result = await districtCtv(district)
      if (result.status) {
        this.ctvs = result.data
      } else {
        this.error = true
      }
      this.message = result.message
      this.isLoading = false
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCtvCachedStore, import.meta.hot))
}
